import styles from './styles.module.scss'
import Image from 'next/image'
import { useAppIntl } from 'src/i18n'

export const ContentHeader = ({
  getGeneralRatingScore,
  ratingsData,
  title,
  thumbnail,
  affiliateLink,
  slug,
  containerWidth,
  containerHeight,
}) => {
  const intl = useAppIntl()
  const generalRatingScore = getGeneralRatingScore(ratingsData)

  return (
    <div
      className={styles.header}
      style={{ width: containerWidth, height: containerHeight }}
    >
      {' '}
      <div className={styles.header__grid}>
        <div className={styles.header__imageContainer}>
          <Image
            className={styles.header__image}
            alt='Logo'
            src={thumbnail.data?.attributes.url}
            layout='fill'
            objectFit='cover'
            loading='lazy'
          />
        </div>
        <div className={styles.header__reviewName}>
          <h3 className={styles.header__title}>{title}</h3>
          <div className={styles.header__rating}>
            <p className={styles.header__star}>★</p>
            <p className={styles.header__score}>{generalRatingScore}</p>
          </div>
        </div>
        <div className={styles.header__buttons}>
          <a
            className={`${styles.header__visitButton} ${styles.header__button}`}
            href={affiliateLink}
            target='_blank'
            rel='noopener noreferrer nofollow'
          >
            {intl.t('review.buttons.visit')} {title}
          </a>
          <a
            className={`${styles.header__readButton} ${styles.header__button}`}
            href={`/review/${slug}`}
          >
            {intl.t('review.buttons.read')}
          </a>
        </div>
      </div>
    </div>
  )
}
